import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { Assessment, PatchAssessment } from 'src/types/shared/Assessments';

export const patchAssessmentRequest = createAction('patchAssessmentRequest');
export const patchAssessmentSuccess = createAction<Assessment>('patchAssessmentSuccess');
export const patchAssessmentFailure = createAction('patchAssessmentFailure');

export const patchAssessment = (assessment: PatchAssessment) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(patchAssessmentRequest());
    try {
        const { data }: Response = await api.patch('admin/assessments', assessment);

        dispatch(patchAssessmentSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, patchAssessmentFailure, e as any);
    }
};

interface Response {
    data: Assessment;
}
